import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

// 效果 33: 3D 翻转
export const Flip3D: React.FC = () => {
  const frame = useCurrentFrame();
  const rotateY = interpolate(frame, [0, 60, 120], [0, 180, 360], {
    extrapolateRight: "clamp",
  });
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#1a1a2e",
        justifyContent: "center",
        alignItems: "center",
        perspective: "1000px",
      }}
    >
      <div
        style={{
          width: 300,
          height: 300,
          backgroundColor: "#4ecdc4",
          transform: `rotateY(${rotateY}deg)`,
          boxShadow: "0 0 50px rgba(78, 205, 196, 0.5)",
        }}
      />
    </AbsoluteFill>
  );
};

// 效果 35: 深度视差
export const ParallaxLayers: React.FC = () => {
  const frame = useCurrentFrame();
  const moveX = interpolate(frame, [0, 60, 120], [-100, 100, -100]);
  
  return (
    <AbsoluteFill style={{ backgroundColor: "#16213e", overflow: "hidden" }}>
      {[0, 1, 2, 3].map((i) => {
        const depth = i + 1;
        const x = moveX * depth * 0.5;
        const size = 100 + i * 50;
        const opacity = 0.3 - i * 0.05;
        
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              width: size,
              height: size,
              backgroundColor: `hsl(${i * 60}, 70%, 50%)`,
              left: `calc(50% + ${x}px)`,
              top: `${i * 150 + 50}px`,
              opacity,
              transform: "translateX(-50%)",
            }}
          />
        );
      })}
    </AbsoluteFill>
  );
};

// 效果 36: 隧道效果
export const TunnelEffect: React.FC = () => {
  const frame = useCurrentFrame();
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#000",
        justifyContent: "center",
        alignItems: "center",
        perspective: "500px",
      }}
    >
      {Array.from({ length: 10 }, (_, i) => {
        const scale = interpolate(
          (frame + i * 10) % 100,
          [0, 100],
          [0.1, 3]
        );
        const opacity = interpolate(
          (frame + i * 10) % 100,
          [0, 100],
          [1, 0]
        );
        
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              width: 100,
              height: 100,
              border: "3px solid #4ecdc4",
              transform: `scale(${scale})`,
              opacity,
            }}
          />
        );
      })}
    </AbsoluteFill>
  );
};

// 效果 37: 星空
export const Starfield: React.FC = () => {
  const frame = useCurrentFrame();
  
  return (
    <AbsoluteFill style={{ backgroundColor: "#000" }}>
      {Array.from({ length: 100 }, (_, i) => {
        const seed = i * 7919;
        const x = (seed % 1280);
        const y = ((seed * 3) % 720);
        const z = (frame + seed) % 100;
        const size = (seed % 3) + 1;
        const brightness = interpolate(z, [0, 100], [1, 0]);
        
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: x,
              top: y,
              width: size,
              height: size,
              backgroundColor: "white",
              borderRadius: "50%",
              opacity: brightness,
            }}
          />
        );
      })}
    </AbsoluteFill>
  );
};
